import * as React from 'react';

import { useSelector } from 'react-redux';
import { PageRedesigned } from './PageRedesigned';
import { checkFsk } from '../../selectors';
import { PageFSK } from './PageFSK';
import { PageTemplateSpecialPromo } from './PagePageTemplateSpecialPromo';
import { useApplicationContext } from '../../utils';
import { useOpenDeveloperCardUxfbEvent } from '../../hooks/uxfb';

export const PageContainer = () => {
  const {
    custom: { isPageTemplateSpecialPromo },
  } = useApplicationContext();

  const isFsk = useSelector(checkFsk);

  useOpenDeveloperCardUxfbEvent();

  if (isPageTemplateSpecialPromo) {
    return <PageTemplateSpecialPromo />;
  }

  if (isFsk) {
    return <PageFSK />;
  }

  return <PageRedesigned />;
};
